import { Api as api } from "../api";
const prefix = "/config";
// const prefix = "";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    waitingTimeServiceV1ListWaitingTimeRates: build.query<
      WaitingTimeServiceV1ListWaitingTimeRatesApiResponse,
      WaitingTimeServiceV1ListWaitingTimeRatesApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/waiting-time-rates`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
          sort: queryArg.sort,
          order: queryArg.order,
          status: queryArg.status,
          waiting_time_rate_name: queryArg.waitingTimeRateName,
          duration_condition: queryArg.durationCondition,
          created_at_from: queryArg.createdAtFrom,
          created_at_to: queryArg.createdAtTo,
          updated_at_from: queryArg.updatedAtFrom,
          updated_at_to: queryArg.updatedAtTo,
          duration: queryArg.duration,
          rate: queryArg.rate,
        },
      }),
    }),
    waitingTimeServiceV1BatchCreateWaitingTimeRate: build.mutation<
      WaitingTimeServiceV1BatchCreateWaitingTimeRateApiResponse,
      WaitingTimeServiceV1BatchCreateWaitingTimeRateApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/waiting-time-rates`,
        method: "POST",
        body: queryArg.waitingTimeV1BatchCreateWaitingTimeRateReq,
      }),
    }),
    waitingTimeServiceV1ActivateWaitingTimeRates: build.mutation<
      WaitingTimeServiceV1ActivateWaitingTimeRatesApiResponse,
      WaitingTimeServiceV1ActivateWaitingTimeRatesApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/waiting-time-rates/activate`,
        method: "PATCH",
        body: queryArg.waitingTimeV1WaitingTimeBulkStatusChangeReq,
      }),
    }),
    waitingTimeServiceV1DeactivateWaitingTimeRates: build.mutation<
      WaitingTimeServiceV1DeactivateWaitingTimeRatesApiResponse,
      WaitingTimeServiceV1DeactivateWaitingTimeRatesApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/waiting-time-rates/deactivate`,
        method: "PATCH",
        body: queryArg.waitingTimeV1WaitingTimeBulkStatusChangeReq,
      }),
    }),
    waitingTimeServiceV1GetWaitingTimeRateDropdown: build.query<
      WaitingTimeServiceV1GetWaitingTimeRateDropdownApiResponse,
      WaitingTimeServiceV1GetWaitingTimeRateDropdownApiArg
    >({
      query: () => ({ url: `${prefix}/v1/waiting-time-rates/dropdown` }),
    }),
    waitingTimeServiceV1GetWaitingTimeRate: build.query<
      WaitingTimeServiceV1GetWaitingTimeRateApiResponse,
      WaitingTimeServiceV1GetWaitingTimeRateApiArg
    >({
      query: (queryArg) => ({ url: `${prefix}/v1/waiting-time-rates/${queryArg.id}` }),
    }),
    waitingTimeServiceV1UpdateWaitingTimeRate: build.mutation<
      WaitingTimeServiceV1UpdateWaitingTimeRateApiResponse,
      WaitingTimeServiceV1UpdateWaitingTimeRateApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/waiting-time-rates/${queryArg.id}`,
        method: "PUT",
        body: queryArg.waitingTimeServiceV1UpdateWaitingTimeRateBody,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as waitingTimeApi };
export type WaitingTimeServiceV1ListWaitingTimeRatesApiResponse =
  /** status 200 A successful response. */ WaitingTimeV1ListWaitingTimeRatesRes;
export type WaitingTimeServiceV1ListWaitingTimeRatesApiArg = {
  page?: number;
  size?: number;
  sort?: string;
  order?: string;
  status?: string;
  waitingTimeRateName?: string;
  durationCondition?: string;
  createdAtFrom?: string;
  createdAtTo?: string;
  updatedAtFrom?: string;
  updatedAtTo?: string;
  duration?: string;
  rate?: string;
};
export type WaitingTimeServiceV1BatchCreateWaitingTimeRateApiResponse =
  /** status 200 A successful response. */ WaitingTimeV1WaitingTimeMessageRes;
export type WaitingTimeServiceV1BatchCreateWaitingTimeRateApiArg = {
  waitingTimeV1BatchCreateWaitingTimeRateReq: WaitingTimeV1BatchCreateWaitingTimeRateReq;
};
export type WaitingTimeServiceV1ActivateWaitingTimeRatesApiResponse =
  /** status 200 A successful response. */ WaitingTimeV1WaitingTimeBulkStatusChangeRes;
export type WaitingTimeServiceV1ActivateWaitingTimeRatesApiArg = {
  waitingTimeV1WaitingTimeBulkStatusChangeReq: WaitingTimeV1WaitingTimeBulkStatusChangeReq;
};
export type WaitingTimeServiceV1DeactivateWaitingTimeRatesApiResponse =
  /** status 200 A successful response. */ WaitingTimeV1WaitingTimeBulkStatusChangeRes;
export type WaitingTimeServiceV1DeactivateWaitingTimeRatesApiArg = {
  waitingTimeV1WaitingTimeBulkStatusChangeReq: WaitingTimeV1WaitingTimeBulkStatusChangeReq;
};
export type WaitingTimeServiceV1GetWaitingTimeRateDropdownApiResponse =
  /** status 200 A successful response. */ WaitingTimeV1GetWaitingTimeRateDropdownRes;
export type WaitingTimeServiceV1GetWaitingTimeRateDropdownApiArg = void;
export type WaitingTimeServiceV1GetWaitingTimeRateApiResponse =
  /** status 200 A successful response. */ WaitingTimeV1WaitingTimeRateDetailRes;
export type WaitingTimeServiceV1GetWaitingTimeRateApiArg = {
  id: string;
};
export type WaitingTimeServiceV1UpdateWaitingTimeRateApiResponse =
  /** status 200 A successful response. */ WaitingTimeV1WaitingTimeMessageRes;
export type WaitingTimeServiceV1UpdateWaitingTimeRateApiArg = {
  id: string;
  waitingTimeServiceV1UpdateWaitingTimeRateBody: WaitingTimeServiceV1UpdateWaitingTimeRateBody;
};
export type WaitingTimeV1WaitingTimeRateRes = {
  id?: string;
  waiting_time_rate_name?: string;
  duration_condition?: string;
  duration_min?: number;
  duration_max?: number;
  rate?: number;
  status?: string;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
};
export type WaitingTimeV1WaitingTimePaginationMeta = {
  total?: number;
  current_page?: number;
  limit?: number;
  total_item?: number;
  total_page?: number;
  have_next_page?: boolean;
  have_previous_page?: boolean;
};
export type WaitingTimeV1ListWaitingTimeRatesRes = {
  waiting_time_rates?: WaitingTimeV1WaitingTimeRateRes[];
  metadata?: WaitingTimeV1WaitingTimePaginationMeta;
};
export type ProtobufAny = {
  "@type"?: string;
  [key: string]: any;
};
export type RpcStatus = {
  code?: number;
  message?: string;
  details?: ProtobufAny[];
};
export type WaitingTimeV1WaitingTimeMessageRes = {
  message?: string;
};
export type WaitingTimeV1CreateWaitingTimeRateItem = {
  waiting_time_rate_name: string;
  duration_condition: string;
  duration_min?: number;
  duration_max?: number;
  rate: number;
  status: string;
};
export type WaitingTimeV1BatchCreateWaitingTimeRateReq = {
  waiting_time_rates: WaitingTimeV1CreateWaitingTimeRateItem[];
};
export type WaitingTimeV1WaitingTimeBulkStatusChangeRes = {
  message?: string;
  updated_count?: number;
};
export type WaitingTimeV1WaitingTimeBulkStatusChangeReq = {
  ids: string[];
};
export type WaitingTimeV1WaitingTimeRateDropdownItem = {
  id?: string;
  waiting_time_rate_name?: string;
};
export type WaitingTimeV1GetWaitingTimeRateDropdownRes = {
  waiting_time_rates?: WaitingTimeV1WaitingTimeRateDropdownItem[];
};
export type WaitingTimeV1WaitingTimeRateDetailRes = {
  id?: string;
  waiting_time_rate_name?: string;
  duration_condition?: string;
  duration_min?: number;
  duration_max?: number;
  rate?: number;
  status?: string;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
};
export type WaitingTimeServiceV1UpdateWaitingTimeRateBody = {
  waiting_time_rate_name: string;
  duration_condition: string;
  duration_min?: number;
  duration_max?: number;
  rate: number;
};
export const {
  useWaitingTimeServiceV1ListWaitingTimeRatesQuery,
  useWaitingTimeServiceV1BatchCreateWaitingTimeRateMutation,
  useWaitingTimeServiceV1ActivateWaitingTimeRatesMutation,
  useWaitingTimeServiceV1DeactivateWaitingTimeRatesMutation,
  useWaitingTimeServiceV1GetWaitingTimeRateDropdownQuery,
  useWaitingTimeServiceV1GetWaitingTimeRateQuery,
  useWaitingTimeServiceV1UpdateWaitingTimeRateMutation,
} = injectedRtkApi;
